export const fbq = {
  id: `${process.env.REACT_APP_FACEBOOK_PIXEL_ID}`,
  options: {
    debug: process.env.NODE_ENV === 'development',
    autoConfig: true
  }
};